import React from "react";
import PanelBody from "../../UI/Panel/PanelBody";
import PanelHead from "../../UI/Panel/PanelHead";
import {ManageSiteTable} from "../../UI/Main/ManageSiteTable";

const ManageSite = () => {
    return (
        <div>
            <PanelHead title="Manage Services" />
            <PanelBody content={<ManageSiteTable />} />
        </div>
    );
};

export default ManageSite;
